

export const ProdutosParticipantes = () => {
    return (
        <div>
            Produtos Participantes
        </div>
    )
}